import { ComponentProps, useEffect, useRef } from "react"
import { twMerge } from "tailwind-merge"

type Props = ComponentProps<"div">

export function Scroller(props: Props) {
  const ref = useRef<HTMLDivElement>(null!)

  useEffect(() => {
    const el = ref.current
    const update = () => {
      const canScrollDown = el.scrollHeight - el.scrollTop > el.clientHeight
      const canScrollUp = el.scrollTop > 0
      if (canScrollDown && canScrollUp) {
        el.style.mask = "linear-gradient(to bottom, black 0%, transparent 0, black 50px, black calc(100% - 50px), transparent 100%)"
      } else if (canScrollUp) {
        el.style.mask = "linear-gradient(to bottom, black 0%, transparent 0, black 50px, black 100%)"
      } else if (canScrollDown) {
        el.style.mask = "linear-gradient(to bottom, black calc(100% - 50px), transparent 100%)"
      }
    }
    el.addEventListener("scroll", update)
    const ro = new ResizeObserver(update)
    update()
    ro.observe(el)
    return () => {
      ro.disconnect()
      el.removeEventListener("scroll", update)
    }
  }, [])

  return <div {...props} className={twMerge("overflow-y-auto", props.className)} ref={ref} />
}
